export default __webpack_public_path__ + "static/media/fashion_designer.0dd8d66a.png";